import React from "react";
import { CheckCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/solid";

export default function SubscriptionStatusBadge({ isCancelled = false }) {
  return (
    <div className="absolute top-2 right-2 group inline-block">
      <div
        className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium transition-all duration-200
          ${isCancelled ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-700'}`}
      >
        {isCancelled ? (
          <>
            <ExclamationTriangleIcon className="w-4 h-4 mr-1" />
            Will Not Auto Renew
          </>
        ) : (
          <>
            <CheckCircleIcon className="w-4 h-4 mr-1" />
            Active
          </>
        )}
      </div>

      {/* Tooltip */}
      <div className="absolute hidden group-hover:block z-10 mt-2 left-1/2 -translate-x-1/2 bg-white text-gray-700 text-xs shadow-md rounded-md px-3 py-2 w-56">
        {isCancelled
          ? "This plan will remain active until the current billing period ends. It won't renew automatically."
          : "This subscription is active and will auto-renew on your billing date."}
      </div>
    </div>
  );
}
